import mercadoPagoLogo from '../assets/mercado-pago.svg'
import flowLogo from '../assets/logo-flow.png'
import fintocLogo from '../assets/logo-fintoc.png'
import ventiPayLogo from '../assets/venti-logo.png'
import othersLogo from '../assets/logo-mercado-pago-flow-fintoc.png'
import transferLogo from '../assets/logo-transfer.png'
import creditDebitLogo from '../assets/logo-visa-mastercard-background-white.png'

export const TBK_ENVIRONMENT = process.env.REACT_APP_TRANSBANK_ENVIRONMENT || 'DEV'
export const BAASKIT_ENVIRONMENT = process.env.REACT_APP_BAASKIT_ENVIRONMENT || 'development'
export const KLAP_SDK_URL = process.env.REACT_APP_KLAP_SDK_URL || ''
export const IS_KLAP_ENABLED = KLAP_SDK_URL.length > 0

export const BAASKIT = 'baaskit'
export const KLAP = 'klap'
export const WEBPAY = 'webpay'
export const GETNET = 'getnet'
export const GETNET_POS = 'getnet_pos'
export const OTHERS = 'others'
export const MERCADOPAGO = 'mercadopago'
export const MERCADOPAGO_API = 'mercadopago_api'
export const FLOW = 'flow'
export const VENTIPAY = 'ventipay'
export const FINTOC = 'fintoc'

export const PAYMENT_STAGE_DEVELOP = 'develop'
export const PAYMENT_STAGE_PRODUCTION = 'production'

export const POS_ACTIVATION_CODE_PREFIX = 'VENTA-POS-'
export const POS_DISCOUNT_TYPE = 'pos'
export const POS_POLL_MAX_RETRIES = 30
export const POS_POLL_RETRY_DELAY = 10000

export const PINFLAG_PAYMENT_METHODS = [
  KLAP,
  GETNET,
  WEBPAY
]

export const PINFLAG = 'pinflag'

export const SHOPIFY_PINFLAG_PAYMENT_METHOD = 'Pinflag'

export const DEFAULT_SSN = '66666666-6'

export const MERCADOPAGO_PAYMENT_OPTION = {
  type: MERCADOPAGO,
  title: 'MercadoPago',
  subTitle: '',
  logo: mercadoPagoLogo,
  logoWidth: '35px'
}

export const FLOW_PAYMENT_OPTION = {
  type: FLOW,
  title: 'Flow',
  subTitle: '',
  logo: flowLogo,
  logoWidth: '35px'
}

export const VENTIPAY_PAYMENT_OPTION = {
  type: VENTIPAY,
  title: 'VentiPay',
  subTitle: '',
  logo: ventiPayLogo,
  logoWidth: '25px'
}

export const FINTOC_PAYMENT_OPTION = {
  type: FINTOC,
  title: 'Fintoc',
  subTitle: '',
  logo: fintocLogo,
  logoWidth: '30px'
}

export const PINFLAG_PAYMENT_OPTIONS = [
  {
    type: 'credit',
    title: 'Tarjeta de Crédito',
    subTitle: 'Visa, Mastercard',
    logo: creditDebitLogo,
    logoWidth: '55px'
  },
  {
    type: 'debit',
    title: 'Tarjeta de Débito',
    subTitle: 'Visa, Mastercard',
    logo: creditDebitLogo,
    logoWidth: '55px'
  },
  {
    type: 'transfer',
    title: 'Transferencia Bancaria',
    subTitle: 'Desde tu banco',
    logo: transferLogo,
    logoWidth: '95px'
  },
  {
    type: 'others',
    title: 'Otros',
    subTitle: '',
    logo: othersLogo,
    logoWidth: '65px'
  }
]

export const PINFLAG_PAYMENT_MESSAGE = {
  baaskit: {
    debit: 'Debit Card (Baaskit)',
    credit: 'Credit Card (Baaskit)'
  },
  klap: {
    debit: 'Debit Card (Klap)',
    credit: 'Credit Card (Klap)'
  },
  getnet: {
    debit: 'Debit Card (Getnet)',
    credit: 'Credit Card (Getnet)'
  },
  webpay: {
    debit: 'Debit Card (Webpay)',
    credit: 'Credit Card (Webpay)'
  },
  mercadopago: {
    mercadopago: 'MercadoPago'
  },
  mercadopago_api: {
    debit: 'Debit Card (Mercado Pago)',
    credit: 'Credit Card (Mercado Pago)'
  },
  flow: {
    flow: 'Flow'
  },
  ventipay: {
    ventipay: 'VentiPay'
  },
  fintoc: {
    fintoc: 'Fintoc'
  },
  getnet_pos: {
    pos: 'POS (Getnet)'
  }
}

export const PAYMENT_ALREADY_IN_PROGRESS_STATUS = 409

export const PAYMENT_CONFIRMATION_ERROR = {
  code: '005',
  message: 'Ocurrió un error al confirmar tu pago, por favor intenta nuevamente.'
}

export const GUEST_PAYMENT_TIMEOUT_MS_BY_GATEWAY = {
  [MERCADOPAGO_API]: 6000
}

export const CARD_DISCOUNT_TYPES = {
  PERCENTAGE: 'percentage',
  FIXED_AMOUNT: 'fixed_amount'
}

export const CARD_DISCOUNT_SCOPES = {
  TOTAL: 'total',
  CART: 'cart',
  SHIPPING: 'shipping'
}

export const DISCOUNT_CHANGED_ERROR_CODE = 'DISCOUNT_CHANGED'

export const CARD_PAYMENT_OPTIONS = {
  CREDIT: 'credit',
  DEBIT: 'debit'
}

export const MERCADOPAGO_API_DEFAULT_ERROR_CODE = '000'
export const MERCADOPAGO_API_DEFAULT_ERROR_MESSAGE = 'Ocurrió un error al procesar el pago.'
export const MERCADOPAGO_API_MISSING_PUBLIC_KEY_MESSAGE = 'Falta la llave pública de Mercado Pago'
export const MERCADOPAGO_API_CRITICAL_ERROR_TYPE = 'critical'

export const MERCADOPAGO_API_DISCOUNT_CHANGED_REJECTION = {
  code: '000',
  message: 'El descuento de tu tarjeta cambió. Revisa el nuevo monto y vuelve a pagar.'
}

export const MERCADOPAGO_API_PENDING_ORDER_REJECTION = {
  code: '005',
  message: 'No pudimos preparar tu compra. Por favor, intenta nuevamente.'
}

export const MERCADOPAGO_API_DEBIT_CARD_PAYMENT_TYPE = 'debit_card'
export const MERCADOPAGO_API_BIN_LENGTH = 6
export const MERCADOPAGO_API_FORM_LOAD_TIMEOUT_MS = 15000
export const MERCADOPAGO_API_FORM_LOAD_ERROR_MESSAGE =
  'No se pudo cargar el formulario de pago. Por favor, intenta nuevamente.'
export const MERCADOPAGO_API_BRICK_CUSTOMIZATION = { visual: { hideFormTitle: true } }

export const CARD_NUMBER_MAX_LENGTH = 19
export const MASTERCARD_BIN_PATTERN = /^(5[1-5]|222[1-9]|22[3-9]\d|2[3-6]\d{2}|27[01]\d|2720)/
export const REFERENCE_ID_MAX_LENGTH = 15
export const MAX_INSTALLMENTS = 12
export const INSTALLMENT_OPTIONS = Array.from({ length: MAX_INSTALLMENTS }, (_, index) => index + 1)
